import useReportFetchByDate from "hooks/useReportFetchByDate";
import React, { createContext } from "react";

export const reportContext = createContext();

function ReportContext({ type, types, children }) {
	const reportData = useReportFetchByDate(type || "");

	return (
		<reportContext.Provider value={{ ...reportData, types }}>
			{children}
		</reportContext.Provider>
	);
}

export default ReportContext;
